import cx from 'classnames';

import { Snackbar as MuiSnackbar } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import {
  STATUS_ERROR,
  STATUS_INFO,
  STATUS_SUCCESS,
  STATUS_WARNING,
} from '../../constants/statuses';

export const styles = ({ palette, breakpoints }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '44px',
    [breakpoints.up('sm')]: {
      maxWidth: '720px',
    },
  },
  defaultStatus: {
    backgroundColor: palette.status.notStarted,
  },
  [STATUS_SUCCESS]: {
    backgroundColor: palette.status.success,
  },
  [STATUS_WARNING]: {
    backgroundColor: palette.status.warning,
  },
  [STATUS_ERROR]: {
    backgroundColor: palette.status.fail,
  },
  [STATUS_INFO]: {
    backgroundColor: palette.status.awaiting,
  },
});

export function Snackbar({
  action = null,
  autoCloseDuration = null,
  children = null,
  classes = {},
  onClose = () => {},
  isOpen = false,
  status = 'default',
  ...otherProps
}) {
  const statusClassname = classes[status] || classes.defaultStatus;

  return (
    <MuiSnackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      ContentProps={{ classes: { root: cx(statusClassname, classes.container) } }}
      action={action}
      open={isOpen}
      message={children}
      autoHideDuration={autoCloseDuration}
      onClose={onClose}
      {...otherProps}
    />
  );
}

export default withStyles(styles)(Snackbar);
